import { render, staticRenderFns } from "./GoodsDelete.vue?vue&type=template&id=767ac5de&scoped=true&"
import script from "./GoodsDelete.vue?vue&type=script&lang=js&"
export * from "./GoodsDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767ac5de",
  null
  
)

export default component.exports